module.exports = ".pageNumber{background:#c5c5c5;padding:2px;outline-offset:-2px;line-height:1em;margin:0 1px}.pageNumber::selection{display:none}"